const SESSION_STORAGE_KEY = "crm-agent-session-id";

/** Stable browser-tab session for Redis chat memory across sheet open/close. */
export function getAgentSessionId(): string {
  if (typeof window === "undefined") {
    return crypto.randomUUID();
  }

  try {
    const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (existing) return existing;

    const created = crypto.randomUUID();
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}

/** Start a fresh agent conversation (new Redis memory key). */
export function clearAgentSessionId(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // ignore quota / private-mode errors
  }
}
